<div class="common-text-input__dependencies-block"
  [ngClass]="{'common-text-input__dependencies-block--find-dependencies':fieldReferences.dependencies?.relatedConcept?.length || fieldReferences.dependencies?.length}">
  @if (!fieldReferences.dependencies?.relatedConcept?.length && !fieldReferences.dependencies?.length && !loadingDependencies) {
    <div class="common-spinner__block-spinner-description">
      <p class="common-text-input__dependencies-empty-block"
        [afTranslate]="'field-items.no-dependencies'">_No se han encontrado dependencias.</p>
    </div>
  }
  @if (loadingDependencies) {
    <div class="common-spinner__block-spinner-description">
      <p-progressSpinner styleClass="common-spinner__progress-container-color-MD"
        ariaLabel="loading"></p-progressSpinner>
      <span class="common-spinner__description-text-color-grey"
        [afTranslate]="'field-references.tracking-dependencies'">Descripción</span>
    </div>
  }@else {
    @for (dependencies of fieldReferences.dependencies; track $index) {
      <div class="common-text-input__dependencies-item"
        [ngClass]="{'common-text-input__dependencies-item--no-boder': fieldReferences.dependencies.length === 1}">
        <div class="common-text-input__dependencies-item-header">
          <i class="lf-icon-connected-data common-icon__md-grey-800"></i>
          <p class="common-text-input__dependencies-concept common-text-input__dependencies-concept--inner">
            <span class="common-text-input__dependencies-concept">{{dependencies.name}}</span>
          <span>
              {{'('+dependencies.parentName}}
            </span>
            <span> > </span>
            @for (folder of dependencies.folders; track $index) {
              <span>
                {{$last?folder.folderName+')':folder.folderName}}
                @if (!$last) {
                  <span> > </span>
                }
              </span>
            }</p>
        </div>
        @if(dependencies.relatedConcept.length){
          <ul class="common-text-input__dependencies-concept-list">
            @for (concept of  dependencies.relatedConcept; track $index) {
              <li class="common-text-input__dependencies-concept-list-item">
                <button  (click)="openConcept(concept)">
                  <span-tooltip text="{{'-'+ concept.relatedConceptName}}">
                  </span-tooltip>
                </button>
              </li>
            }
          </ul>
        }
      </div>
    }
  }
</div>
